import type { JSX } from 'react';
import { useLocale } from '@gs/i18n/localeContext';
import { formatBuildStamp, useBuildInfo } from '../hooks/useBuildInfo';

// Copie interne FR/EN (precedent GsPreproductionBanner) : le MEME mot dans toutes les apps,
// sans une cle de catalogue par app. Zero t() dans @gs/ui.
const COPY = {
  fr: { label: 'version', title: 'Version construite' },
  en: { label: 'build', title: 'Deployed build' },
} as const;

export interface GsBuildStampProps {
  /**
   * Separateur rendu AVANT la version, et seulement si elle s affiche (` · ` dans le bandeau,
   * le pied du menu) : l appelant n a pas a savoir si la lecture est revenue.
   */
  lead?: string;
}

/**
 * La version de la construction qui sert la page : SHA court du commit et date de
 * construction, lus de `/api/version` a l origine de la page (lot feat-la-version-se-voit-partout).
 *
 * Le MEME composant, donc la meme forme, dans le pied du menu utilisateur (production) et dans
 * le bandeau de preproduction : la comparaison se fait d un coup d oeil. Texte discret (slate,
 * chiffres a chasse fixe), herite la taille et la couleur de son contenant.
 *
 * Ne rend rien tant que la lecture n est pas revenue, sur une panne, et quand le serveur ne
 * donne pas de SHA : une version que personne n a donnee ne s invente pas.
 */
export function GsBuildStamp({ lead }: GsBuildStampProps): JSX.Element | null {
  const info = useBuildInfo();
  const localeCtx = useLocale();
  const copy = COPY[localeCtx?.locale === 'en' ? 'en' : 'fr'];
  const stamp = info ? formatBuildStamp(info) : null;
  if (!stamp) return null;

  return (
    <>
      {lead}
      <span data-gs-build-stamp="" title={copy.title}>
        {copy.label} <span className="font-mono tabular-nums">{stamp}</span>
      </span>
    </>
  );
}
